const tours = {
	crosstabs: [
		{
			text: "Hello",
			element: "#read_totalArticles",
			offset: { top: 30 },
		},
		{
			text: "World",
			element: "#ftux_leftFilterBox",
			offset: { right: 130 },
		},
	],
};

export default tours;
